import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import Colors from "../../Constants/Colors";
import {tokens} from "../../theme/tokens";
import avatar from "../../Assets/Images/a3.png";
import {Link} from "react-router-dom";
import {Guard} from "../Common/Guard";
import {PERMS} from "../../Utils/Permissions";
import {currentUser} from "../../Utils/Auth";

const SideBarNav = props => {

    let d = new Date();

    const [globalState, globalActions] = useGlobal();
    const [currentYear, setCurrentYear] = useState(d.getFullYear())
    const isSuperAdmin = (currentUser()?.role || '') === 'super_admin'

    return (
        <nav className="side-menu" style={{
            backgroundImage: `linear-gradient(180deg, ${tokens.colors.ink} 0%, ${tokens.colors.inkDeep} 100%)`,
            backgroundColor: tokens.colors.ink,
            padding: '28px 0 0 !important'
        }}>
            <ul className="side-menu-list" style={{margin: '0 0 10px 0'}}>
                <div className="side-menu-avatar" style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.22)',
                    padding: '5px 0 0 !important'
                }}>
                    <div className="avatar-preview avatar-preview-100">
                        <img src={avatar} alt="" className="userPhoto"/>
                    </div>

                    <div className="text-center p-3" style={{paddingBottom: '0 !important'}}>
                        <h5 className="text-white font-weight-bold"
                            style={{marginBottom: 2}}>{globalState.currentUser.name}</h5>
                        <span style={{color: Colors.white}}>{globalState.currentUser.email}</span>
                    </div>

                </div>

                 <li className="grey">
                    <Link to={"/dashboard"}>
                        <i className="fa fa-home"></i>
                        <span className="lbl">Dashboard</span>
                    </Link>
                </li>

                {/*All requests */}
                <Guard permission={PERMS.REQUEST_READ}>
                    <li className="grey">
                        <Link to={"/requests"}>
                            <i className="fa fa-list"></i>
                            <span className="lbl">Requests</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.REQUEST_READ}>
                    <li className="grey">
                        <Link to={"/request-logs"}>
                            <i className="fa fa-clipboard-list"></i>
                            <span className="lbl">Request Logs</span>
                        </Link>
                    </li>
                </Guard>

                {/*Normal / Corporate */}
                <Guard permission={PERMS.REQUEST_READ}>
                    <li className="grey">
                        <Link to={"/clients"}>
                            <i className="font-icon font-icon-users-two"></i>
                            <span className="lbl">Clients</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.REQUEST_READ}>
                    <li className="grey">
                        <Link to={"/businesses"}>
                            <i className="font-icon font-icon-users"></i>
                            <span className="lbl">Businesses</span>
                        </Link>
                    </li>
                </Guard>

                {/*Active / Inactive */}
                <Guard permission={PERMS.RIDER_READ}>
                    <li className="grey">
                        <Link to={"/riders"}>
                            <i className="fa fa-bicycle"></i>
                            <span className="lbl">Riders</span>
                        </Link>
                    </li>
                </Guard>

                {/*Active / Inactive ==> Ride types, Car types, Services, Rates,  */}
                <Guard permission={PERMS.PRICING_READ}>
                    <li className="grey">
                        <Link to={"/areas"}>
                            <i className="fa fa-map"></i>
                            <span className="lbl">Areas</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.PRICING_WRITE}>
                    <li className="grey">
                        <Link to={"/countries"}>
                            <i className="fa fa-globe"></i>
                            <span className="lbl">Countries</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.BROADCAST_WRITE}>
                    <li className="grey">
                        <Link to={"/broadcasts"}>
                            <i className="fa fa-comment"></i>
                            <span className="lbl">Broadcasts</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.PROMO_WRITE}>
                    <li className="grey">
                        <Link to={"/promotions"}>
                            <i className="fa fa-dollar"></i>
                            <span className="lbl">Promotions</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.REQUEST_READ}>
                    <li className="grey">
                        <Link to={"/complaints"}>
                            <i className="fa fa-exclamation-circle"></i>
                            <span className="lbl">Complaints</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.REQUEST_READ}>
                    <li className="grey">
                        <Link to={"/reverse-timer"}>
                            <i className="fa fa-hourglass-half"></i>
                            <span className="lbl">Reverse Timer</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.FINANCIAL_READ}>
                    <li className="grey">
                        <Link to={"/transactions"}>
                            <i className="fa fa-exchange"></i>
                            <span className="lbl">Transactions</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.AUDIT_READ}>
                    <li className="grey">
                        <Link to={"/audit"}>
                            <i className="fa fa-history"></i>
                            <span className="lbl">Audit Log</span>
                        </Link>
                    </li>
                </Guard>

                {isSuperAdmin &&
                    <li className="grey">
                        <Link to={"/system-reset"}>
                            <i className="fa fa-trash"></i>
                            <span className="lbl">System Reset</span>
                        </Link>
                    </li>
                }

                <Guard permission={PERMS.RIDER_READ}>
                    <li className="grey">
                        <Link to={"/leaderboard"}>
                            <i className="fa fa-trophy"></i>
                            <span className="lbl">Leaderboard</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.FINANCIAL_READ}>
                    <li className="grey">
                        <Link to={"/loans"}>
                            <i className="fa fa-money"></i>
                            <span className="lbl">Fuel loans</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.FINANCIAL_READ}>
                    <li className="grey">
                        <Link to={"/analytics"}>
                            <i className="fa fa-bar-chart"></i>
                            <span className="lbl">Owner dashboard</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.RIDER_READ}>
                    <li className="grey">
                        <Link to={"/rider-performance"}>
                            <i className="fa fa-line-chart"></i>
                            <span className="lbl">Rider performance</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.RIDER_READ}>
                    <li className="grey">
                        <Link to={"/flagged-users"}>
                            <i className="fa fa-flag"></i>
                            <span className="lbl">Flagged users</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.RIDER_APPROVE}>
                    <li className="grey">
                        <Link to={"/rider-vetting"}>
                            <i className="fa fa-user-plus"></i>
                            <span className="lbl">Rider vetting</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.PRICING_WRITE}>
                    <li className="grey">
                        <Link to={"/transfer-hubs"}>
                            <i className="fa fa-exchange"></i>
                            <span className="lbl">Transfer hubs</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.ADMIN_WRITE}>
                    <li className="grey">
                        <Link to={"/admins"}>
                            <i className="fa fa-user-secret"></i>
                            <span className="lbl">Admins</span>
                        </Link>
                    </li>
                </Guard>

                <Guard permission={PERMS.ADMIN_WRITE}>
                    <li className="grey">
                        <Link to={"/roles"}>
                            <i className="fa fa-shield"></i>
                            <span className="lbl">Roles</span>
                        </Link>
                    </li>
                </Guard>

                <li className="grey">
                    <a href={"https://pickanddrop.zendesk.com/"} target={"_blank"}>
                        <i className="fa fa-ticket"></i>
                        <span className="lbl">Support (ZenDesk)</span>
                    </a>
                </li>

                <li className="grey">
                    <Link to={"/settings"}>
                        <i className="fa fa-cogs"></i>
                        <span className="lbl">Settings</span>
                    </Link>
                </li>

            </ul>

            <section>
                <header className="side-menu-title" style={{fontSize: 13}}>
                    {`© P&D Admin ${currentYear} v1.0.1`}
                </header>
            </section>
        </nav>
    )
};

export default SideBarNav;
